export default {
  'create-projects': 'Project aanmaken',
  'join-projects': 'Projectdeelname',
  'view-projects': 'Projecten inzien',
  'test-own-projects': 'Eigen projecten toetsen',
  'update-bindings-on-own-projects': 'Richtlijnen in eigen projecten naar huidige versie zetten',
  'mark-irrelevant-on-own-projects': 'Richtlijnen als irrelevant markeren',
  'add-custom-rules': 'Projectspecifieke richtlijnen beheren',
  'manage-projects': 'Projectenbeheer',
  'promote-delete-projects': 'Promoveer/verwijder projecten',
  'import-projects-from-external': 'Projecten importeren',
  'manage-rules': 'Richtlijnbeheer',
  'manage-phases': 'Fasebeheer',
  'manage-categories': 'Categoriebeheer',
  'manage-internal-categories': 'Interne categorieën en bijbehorende richtlijnen beheren',
  'manage-themes': 'Themabeheer',
  'manage-maps': 'Kaartbeheer',
  'manage-objects': 'Inrichtingselementenbeheer',
  'manage-users': 'Gebruikersbeheer',
  'manage-roles': 'Rechtenbeheer',
  'external-api-access': 'Externe api',
  'delete-from-archive': 'Uit archief verwijderen',
}
